import React from 'react';
import styled from 'styled-components';
import SectionHeader from '../common/SectionHeader';
import Container from '../common/Container'; // ✅ PASSO 1: Importe o componente Container
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt, faFileInvoiceDollar, faHistory, faTachometerAlt, faClipboardCheck, faMobileAlt } from '@fortawesome/free-solid-svg-icons';

const FeaturesWrapper = styled.section`
  padding: 120px 0;
  position: relative;
  background-color: ${({ theme }) => theme.colors.light};
  overflow: hidden;
`;

const FeaturesBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
`;

const FeaturesBgPattern = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: radial-gradient(rgba(108, 92, 231, 0.08) 1px, transparent 1px);
  background-size: 20px 20px;
  opacity: 0.6;
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: 1fr;
  }
`;

const FeatureCard = styled.div`
  background: ${({ theme }) => theme.colors.lighter};
  border-radius: ${({ theme }) => theme.radii.lg};
  padding: 40px 32px;
  transition: ${({ theme }) => theme.transitions.default};
  box-shadow: ${({ theme }) => theme.shadows.sm};
  border: 1px solid rgba(0, 0, 0, 0.03);
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-10px);
    box-shadow: ${({ theme }) => theme.shadows.lg};
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 0;
    background: linear-gradient(to bottom, ${({ theme }) => theme.colors.primary}, ${({ theme }) => theme.colors.accent});
    transition: ${({ theme }) => theme.transitions.default};
  }

  &:hover::before {
    height: 100%;
  }
`;

const FeatureIcon = styled.div`
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, rgba(108, 92, 231, 0.1) 0%, rgba(0, 206, 201, 0.1) 100%);
  border-radius: ${({ theme }) => theme.radii.md};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 28px;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 24px;
  transition: ${({ theme }) => theme.transitions.default};

  ${FeatureCard}:hover & {
    transform: rotate(10deg) scale(1.1);
    background: linear-gradient(135deg, rgba(108, 92, 231, 0.2) 0%, rgba(0, 206, 201, 0.2) 100%);
  }
`;

const FeatureTitle = styled.h3`
  font-size: 22px;
  font-weight: 800;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors.dark};
`;

const FeatureDesc = styled.p`
  color: ${({ theme }) => theme.colors.gray};
  line-height: 1.7;
  font-size: 16px;
`;

const FeaturesSection = () => {
  const features = [
    { icon: faShieldAlt, title: "Proteção contra golpes", desc: "Verifique se o veículo possui registro de roubo ou furto e evite adquirir um bem irregular." },
    { icon: faFileInvoiceDollar, title: "Débitos e multas", desc: "Identifique todos os débitos vinculados ao veículo, incluindo IPVA, licenciamento e multas." },
    { icon: faHistory, title: "Histórico completo", desc: "Acesse o histórico de proprietários, restrições, recalls e todas as alterações no veículo." },
    { icon: faTachometerAlt, title: "Dados técnicos", desc: "Confira todas as especificações do veículo, incluindo motor, combustível e capacidade." },
    { icon: faClipboardCheck, title: "Verificação de recalls", desc: "Saiba se o veículo possui recalls pendentes que podem afetar sua segurança." },
    { icon: faMobileAlt, title: "Relatório no celular", desc: "Receba o relatório completo no seu e-mail e acesse de qualquer dispositivo, a qualquer hora." }
  ];

  return (
    <FeaturesWrapper id="recursos">
      <FeaturesBg>
        <FeaturesBgPattern />
      </FeaturesBg>
      
      {/* ✅ PASSO 2: Substituído o 'FeaturesContainer' pelo componente Container comum */}
      <Container>
        <SectionHeader 
          title="Todas as informações que você precisa"
          subtitle="Nosso relatório completo traz todos os detalhes essenciais para você comprar seu veículo com segurança."
        />
        <FeaturesGrid>
          {features.map(feature => (
            <FeatureCard key={feature.title}>
              <FeatureIcon><FontAwesomeIcon icon={feature.icon} /></FeatureIcon>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDesc>{feature.desc}</FeatureDesc>
            </FeatureCard>
          ))}
        </FeaturesGrid>
      </Container>
    </FeaturesWrapper>
  );
};

export default FeaturesSection;
